module.exports = __webpack_public_path__ + "media/images/hackerrank/frontend-30c745ab17e5951558fa3e71cae969c2.png";